export default "__VITE_ASSET__B0vNrBXU__"